import React from 'react';
import logo from '../../assets/logo.png';

export default function TopBar({ title, subtitle, center, onMobileMenu, right }) {
  return (
    <header className="fr-topbar">
      <div className="fr-topbar__left">
        <button type="button" className="fr-iconButton fr-mobileToggle" onClick={onMobileMenu} aria-label="Abrir menú">
          ☰
        </button>
        <div>
          <div className="fr-logo">
            <img src={logo} alt="FlowraBPA" style={{ height: 22, width: 'auto', display: 'block' }} />
            <span>FlowraBPA</span>
          </div>
          {title ? <div style={{ fontSize: 12, color: 'var(--text-muted)', fontWeight: 700 }}>{title}</div> : null}
        </div>
      </div>
      <div style={{ minWidth: 0, flex: 1 }}>
        {center ? center : subtitle ? <div className="fr-subtitle" style={{ margin: 0 }}>{subtitle}</div> : null}
      </div>
      <div className="fr-topbar__right">{right}</div>
    </header>
  );
}
